__webpack_require__.p = "https://ikea.marat.qd.je/pt/en/customer-service/support/";